export interface AtlBreadcrumbsProps {
    internalId: string;
    internalClassName?: string;
    marginTop?: boolean;
}

export interface AtlBreadcrumbItemProps {
    internalId: string;
    internalClassName?: string;
    clickable?: boolean;
    iconName?: string;
    active?: boolean;
}

export class AtlBreadcrumbClickEvent extends CustomEvent<{ title: string }> {
    static EVENT_NAME = 'atlantis-breadcrumb-click';

    constructor() {
        super(AtlBreadcrumbClickEvent.EVENT_NAME, { bubbles: true, composed: true });
    }
}